import styled from 'styled-components'

const CenteredButton = styled.div`
  display: flex;
  justify-content: center;
  margin: ${(props) => (props.noMargin ? '0' : '32px 0')};
`

export default CenteredButton
